import { IconMailbox, IconSignature } from "@tabler/icons-react";
import styles from "./BuyCreditsButton.module.css";
// @ts-expect-error pure js
import { currencyFormatter } from "../../api/Functions";
// @ts-expect-error pure js
import { TextOneOrMany } from "../../utils/index.jsx";
// @ts-expect-error pure js
import { SIGNATURE_PRICE } from "../../models/signatureElectronique";
// @ts-expect-error pure js
import { ProductType } from "../../utils/constants/stripe";
import Card from "../UI/Card";
import Button from "../UI/Button";
import Text from "../UI/Text";
import Status from "../UI/Status";
import type { StripePrice } from "../../models/stripePrice";

interface BuyCreditsButtonProps {
  price: StripePrice;
  onClick: (priceId: string) => void;
  typeCredits?: string;
}

export default function BuyCreditsButton({
  price,
  onClick,
  typeCredits = ProductType.CREDITS,
}: BuyCreditsButtonProps) {
  const credits = parseFloat(price.credits);
  const priceAmount = price.unit_amount / 100;

  let discount = Math.round((1 - price.unit_amount / credits) * 100);
  let nbSignature = Math.round(credits / SIGNATURE_PRICE);
  let textMany = "signatures électroniques";
  let textOne = "signature électronique";
  if (typeCredits === ProductType.LRAR) {
    discount = 0;
    nbSignature = 1;

    textMany = "courriers recommandés";
    textOne = "courrier recommandé";
  }
  const PriceIcon =
    typeCredits === ProductType.LRAR ? IconMailbox : IconSignature;

  return (
    <Card padding="md" className={styles.card}>
      {discount > 0 && (
        <Status
          color="success"
          text={`-${discount} %`}
          className={styles.discount}
        />
      )}
      <Text weight="bold" className={styles.title}>
        {nbSignature}{" "}
        <TextOneOrMany many={textMany} one={textOne} number={nbSignature} />
      </Text>
      <div className={styles.priceRow}>
        <PriceIcon size={28} stroke={1.5} className={styles.priceIcon} />
        <Text as="span" variant="kilo" weight="bold">
          {currencyFormatter(priceAmount)}
        </Text>
        <Text as="span" variant="deci">
          TTC
        </Text>
      </div>
      {nbSignature > 1 && (
        <Text variant="deci">
          Soit {currencyFormatter(priceAmount / nbSignature)} TTC la signature
        </Text>
      )}
      <Button
        type="button"
        className={styles.buy}
        onClick={() => onClick(price.id)}
      >
        Acheter
      </Button>
    </Card>
  );
}
